<template>
  <div
    class="d-account-dropdown"
    :class="{'has-account-details': showAccoutDetails}"
  >
    <div
      v-if="!$laravel.user"
      class="is-flex is-align-items-center"
    >
      <a
        class="login-button"
        href="/login"
      >
        {{ $t('login') }}
      </a>
      <a
        class="login-button lang-switch"
        :href="'/locale/' + otherLocale"
      >
        &nbsp;|&nbsp;{{ otherLocale.toUpperCase() }}
      </a>
    </div>
    <div
      v-if="$laravel.user"
      class="dropdown is-hoverable is-right"
    >
      <div class="dropdown-trigger">
        <button
          class="avatar"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
        >
          <img
            :src="$laravel.user.avatar_url"
            alt="Avatar"
            class="is-avatar"
          >
          <div
            v-if="showAccoutDetails"
            class="has-text-left"
          >
            <p class="has-text-weight-medium">
              {{ $laravel.user.name }}
            </p>
            <p class="has-text-grey">
              {{ $laravel.user.email }}
            </p>
          </div>
        </button>
      </div>
      <div
        id="dropdown-menu"
        class="dropdown-menu"
        role="menu"
      >
        <div class="dropdown-content">
          <a
            href="/admin"
            class="dropdown-item"
          >
            <span class="icon">
              <i class="mdi mdi-home mdi-18px" />
            </span>
            <span>{{ $t('home') }}</span>
          </a>
          <a
            :href="'/locale/' + otherLocale"
            class="dropdown-item"
          >
            <span class="icon">
              <i class="mdi mdi-translate mdi-18px" />
            </span>
            <span>{{ otherLocale === 'en' ? 'English' : 'Français' }}</span>
          </a>
          <a
            href="/admin/account"
            class="dropdown-item"
          >
            <span class="icon">
              <i class="mdi mdi-account-circle mdi-18px" />
            </span>
            <span>{{ $t('account') }}</span>
          </a>
          <hr>
          <a
            href="#"
            class="dropdown-item"
            @click.prevent="$logout()"
          >
            <span class="icon">
              <i class="mdi mdi-logout mdi-18px" />
            </span>
            <span>
              {{ $t('logout') }}
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    otherLocale() {
      return this.$laravel.app.locale === "fr" ? "en" : "fr";
    },
  },
  props: {
    showAccoutDetails: {
      default: true,
      type: Boolean
    }
  }
};
</script>
